import { post, put } from './Api';

const endpoint = 'suppliers';
export const create = async (data) => await post(`${endpoint}`, data);
export const update = async (data) => await put(`${endpoint}`, data);

